import React from "react";
// SCSS
import "./experience.scss";
//Assets

//Components
import Title from "../ui-components/title/title";
import { experienceData } from '../../data/experienceData'
import ExperienceCard from './ExperienceCard';

//const [isActive, setIsActive] = useState(false);


const experience = () => (
    <div className="experience" id="experience">
        <div className="wrapper">
            <Title title="Experience." />
            <div className="experienceContainer">
                {experienceData.map(exp => (
                    <ExperienceCard
                        key={exp.id}
                        id={exp.id}
                        jobtitle={exp.jobtitle}
                        company={exp.company}
                        startYear={exp.startYear}
                        endYear={exp.endYear}
                        desc1={exp.desc1}
                        desc2={exp.desc2}
                        desc3={exp.desc3}
                        desc4={exp.desc4}
                    />
                ))}
            </div>
        </div>
    </div>
);

export default experience;
